import { alovaInstance, withMeta } from "@@/alova";

interface Options {
  /** 类型 */
  id: string;
}

/**
 * @description 获取内容库游戏信息
 */
export const getContentGameInfo = (params?: Options) => {
  return withMeta(
    alovaInstance.Post<{
      packageName: string;
    }>(`yMHPNHPeN3MmYPMeSTHbeMYb/repositoryAndroid/gameDetail/getGameDetailById`, params, {
      params
    }),
    {
      toast: true,
      resAll: true,
      baseURL: "https://api.233lyly.com/apiserv/"
    }
  );
};
